export default __webpack_public_path__ + "static/media/Bands of the Outer Dark.8539161d.jpg";